import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import t from 'helpers/I18n'

import {AiFillWarning} from "react-icons/ai";
import cities from 'assets/data/cities.json'
const lang = localStorage.getItem('language')?.toLowerCase()
//import InputField from "../base-components/base-input";

const language = lang || "fr"
//const isEn = language === "en"
const isFr = language === "fr"
const isNl = language === "nl"

const SuggestList = ({ suggest, getSelectedCity, val }) => {

    // val.replace(/(?=[() ])/g, '\\')
    const valueRegex = new RegExp(val.replace(/(?=[() ])/g, '\\'), 'gi')
    const resuggest = suggest.map(city => {
        return {
            ...city,
            ZipCode: city.ZipCode,
            Description:  (isFr ? city.DescriptionFr : isNl ? city.DescriptionNl : city.DescriptionFr).replace(valueRegex, '<b>' + val + '</b>')
        }
    })
  return (
      <div className={"suggest-list"} >
          <ul>
              {suggest.length > 0 &&
                  resuggest.map(
                      (city, i) => (
                        <li key={i + "-" + city.ZipCode } onClick={() => getSelectedCity(city)} dangerouslySetInnerHTML={{__html:`${city.Description} (${city.ZipCode})`}} />
                      )
                      )
              }

              {suggest.length < 1 && <li ><i> {t("personal_infos.Personal_info_address.no_result")} </i>  </li> }
          </ul>
      </div>
  )
}

const PostalCode = ( props ) => {
    const input = useRef()
    const { name, label, value, inputError, getInputValue, getPostalValidity } = props
    const _className = "textField " + name
    const [suggest, setSuggest] = useState([])
    const [inputValue, setInputValue] = useState(value !== "NULL" && value !== "NULL (NULL)" ? value : '')
    const [_inputError, setInputError] = useState(false)
    const error_className = _inputError ? "hello-input error" : "hello-input "
    const [cityChoosed, setCityChoosed] = useState(value)


    const noSpecialChar = e => /[&|@"#§^¨!{}_[\]*$%?,.;:\/+=~\\<>°]/.test(e)

    const getSelectedCity = (city) => {
        const select = `${isFr ? city.DescriptionFr 
                        : isNl ? city.DescriptionNl 
                : city.DescriptionFr} (${city.ZipCode})`

        const postalArr = [
                        {
                name: 'zip_code',
                select: city.ZipCode
            },
            {
                name: 'city',
                select: isFr ? city.DescriptionFr : isNl ? city.DescriptionNl : city.DescriptionFr
            },
        ]
        setInputValue(select)
        postalArr.forEach(postalItem => {
            getInputValue(postalItem.name, postalItem.select)
        })
        getInputValue('__postal-input', select)
        setSuggest([])
        setInputError(false)
        setCityChoosed(select)
        getPostalValidity(true)
    
    }

    useEffect(() => {
        getPostalValidity(inputValue === cityChoosed)
    }, [cityChoosed])

    const getPostalCode = (e) => {
        const val = e.target.value
        if (val.length > 0 && val.trim() !== " ") {
            return cities.filter(city => {
                if (isFr) { 
                    return (
                    city.ZipCode.toString().startsWith(val.toLowerCase())
                    // ||  city.DescriptionEn.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // ||  city.DescriptionFr.toString().toLowerCase().startsWith(val.toLowerCase().trim())
                    ||  city.DescriptionFr.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // || city.DescriptionNl.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionEn} (${city.ZipCode})   `).toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionFr } (${city.ZipCode})   `).startsWith().includes(val.toLowerCase().trim())
                    ||  (`${city.DescriptionFr } (${city.ZipCode})   `).toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionNl} (${city.ZipCode})    `).toLowerCase().includes(val.toLowerCase().trim())
                    )
                    
                }
                if (isNl) {
                    return (
                    city.ZipCode.toString().startsWith(val.toLowerCase())
                    // ||  city.DescriptionEn.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // ||  city.DescriptionFr.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // || city.DescriptionNl.toString().toLowerCase().startsWith(val.toLowerCase().trim())
                    || city.DescriptionNl.toString().toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionEn} (${city.ZipCode})   `).toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionFr } (${city.ZipCode})   `).toLowerCase().includes(val.toLowerCase().trim())
                    // ||  (`${city.DescriptionNl} (${city.ZipCode})    `).startsWith().includes(val.toLowerCase().trim())
                    ||  (`${city.DescriptionNl} (${city.ZipCode})    `).toLowerCase().includes(val.toLowerCase().trim())
                )
                }
            })
        } else {
            return []
        }

    }

    const handleInputChange = (e) => {
        if (!noSpecialChar(e.target.value)) {
            // if (e.target.value.length > 0) {
            getPostalValidity(inputValue === cityChoosed && inputValue.length > 1)
            setInputValue(e.target.value)
            getInputValue(name, e.target.value)
            setSuggest([...getPostalCode(e).slice(0, 10)])
            // }
        } else {
            setInputError({ error: t('error_messages.special_caracters') })
       }
    }

    useEffect(() => {
            setInputValue(value !== "NULL" && value !== "NULL (NULL)" ? value : "")
    }, [value])

    return (
        <>
            <div className={_className}>
                <label className={error_className}>
                    <input
                        ref={input}
                        placeholder=" "
                        type={"text"}
                        name={name}
                        id={name}
                        value={inputValue}
                        onChange={handleInputChange}
                        onFocus={handleInputChange}
                        autoComplete="off"
                    />
                    <span>{label}</span>

                    { _inputError &&
                    <p>
                        <AiFillWarning className={"warning"} size={"1.5em"}/>
                        {_inputError.error}
                    </p> }
                </label>
                { inputValue.length > 0 && input.current === document.activeElement &&  <SuggestList val={inputValue} suggest={suggest} getSelectedCity={getSelectedCity} />}
            </div>
        </>
    )
}

SuggestList.propTypes = {
    suggest: PropTypes.array,
    getSelectedCity: PropTypes.func,
}

PostalCode.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.any,
    inputError: PropTypes.object,
    onChange: PropTypes.func,
    getInputValue: PropTypes.func,
}

export default PostalCode